
import styled from 'styled-components';

export const CategoryDetail = styled.div`
  margin-bottom: 2rem;
`

export const CategoryGridProducts = styled.div`
  flex: 1;
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  gap: 2rem;
  margin: 4rem 0;
  @media ${({ theme }) => theme.minScreens.sm} {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media ${({ theme }) => theme.minScreens.md} {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media ${({ theme }) => theme.minScreens.lg} {
    grid-template-columns: repeat(4, 1fr);
  } 
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  position: relative;
  z-index: 10002;
`
